<qvs-status-screen
  class="qvs-validate-payment-order-request-success"
  *ngIf="ordersPaymentRequest as request"
  [title]="'shared.status-screen.SUCCESS' | translate"
  [type]="statusScreenType.SUCCESS"
  [showCloseButton]="request.status !== paymentStatus.DECLINED && request.status !== paymentStatus.UNREGISTERED_TIMED_OUT"
  [closeButtonText]="'payments.CLOSE' | translate"
  (closed)="close()"
>
  <ng-container *ngIf="request.payment as payment">
    <h2 class="qvs-validate-payment-order-request-success__title">
      {{ 'payments.PAYMENT_ORDER_SUBMITTED' | translate }}
    </h2>
    <p
      *ngIf="request.status !== paymentStatus.DECLINED && request.status !== paymentStatus.UNREGISTERED_TIMED_OUT"
      class="qvs-validate-payment-order-request-success__sub-title"
    >
      {{ 'payments.PAYMENT_ORDER_SUBMITTED_DESCRIPTION' | translate }}
    </p>
    <qvs-request-contact
      [text]="'shared.status-screen.CONTACT_SUPPORT_TO_MODIFY' | translate"
      (buttonClick)="close()"
    ></qvs-request-contact>
    <div class="qvs-validate-payment-order-request-success__description">
      <p class="qvs-validate-payment-order-request-success__description__beneficiary">
        {{ payment.beneficiaryName }}
      </p>
      <p
        class="qvs-validate-payment-order-request-success__description__amount"
        [innerHTML]="
          { value: payment.amount, currency: payment.currency?.currency }
            | amount: true : undefined : undefined : undefined : payment.account?.currencyId
        "
      ></p>
      <p *ngIf="payment.executionDate" class="qvs-validate-payment-order-request-success__description__date">
        {{ payment.executionDate | localDate }}
      </p>
    </div>
  </ng-container>
  <ng-container *ngIf="request.transfer as transfer">
    <h2 class="qvs-validate-payment-order-request-success__title">
      {{ 'payments.TRANSFER_ORDER_SUBMITTED' | translate }}
    </h2>
    <qvs-request-contact
      [text]="'shared.status-screen.CONTACT_SUPPORT_TO_MODIFY' | translate"
      (buttonClick)="close()"
    ></qvs-request-contact>
    <div class="qvs-validate-payment-order-request-success__description">
      <p
        class="qvs-validate-payment-order-request-success__description__amount"
        [innerHTML]="
          { value: transfer.amount, currency: transfer.debitAccount.currencyId }
            | amount: true : undefined : undefined : undefined : transfer.creditAccount.currencyId
        "
      ></p>
      <p class="qvs-validate-payment-order-request-success__description__portfolio">
        <span>{{ transfer.debitAccount.portfolio.name }}</span>
        <span>
          {{ transfer.debitAccount.currencyId }} {{ transfer.debitAccount.portfolio.portfolioNumber | accountIdShorten }}
        </span>
      </p>
      <p *ngIf="transfer.executionDate" class="qvs-validate-payment-order-request-success__description__date">
        {{ transfer.executionDate | localDate }}
      </p>
    </div>
  </ng-container>
</qvs-status-screen>
